module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "storegroup"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("账户信息")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("门店分组")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    on: {
      "click": function($event) {
        _vm.resetEditStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "门店名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.mchname),
      callback: function($$v) {
        _vm.$set(_vm.form, "mchname", $$v)
      },
      expression: "form.mchname"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "是否分组"
    },
    model: {
      value: (_vm.form.is_fenzu),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_fenzu", $$v)
      },
      expression: "form.is_fenzu"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "all"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已分组",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未分组",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "门店分组"
    },
    model: {
      value: (_vm.form.groupid),
      callback: function($$v) {
        _vm.$set(_vm.form, "groupid", $$v)
      },
      expression: "form.groupid"
    }
  }, _vm._l((_vm.groupList), function(group) {
    return _c('el-option', {
      key: group.group_id,
      attrs: {
        "label": group.group_name,
        "value": group.group_id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    ref: "province",
    attrs: {
      "size": "small",
      "placeholder": "所属省份"
    },
    on: {
      "change": function($event) {
        _vm.selectProvince()
      }
    },
    model: {
      value: (_vm.form.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.form, "provinceId", $$v)
      },
      expression: "form.provinceId"
    }
  }, _vm._l((_vm.provinces), function(area) {
    return _c('el-option', {
      key: area.full_name,
      attrs: {
        "label": area.full_name,
        "value": area.area_id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "loading": _vm.isCitysLoading,
      "placeholder": "所属地市"
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }, _vm._l((_vm.citys), function(city) {
    return _c('el-option', {
      key: city.area_id,
      attrs: {
        "label": city.full_name,
        "value": city.full_name
      }
    })
  })), _vm._v(" "), _c('footer', [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('h3', [_vm._v("门店分组")]), _vm._v(" "), _c('ul', {
    staticClass: "group-list",
    class: {
      'edit': _vm.isEdit
    }
  }, _vm._l((_vm.groupList), function(group) {
    return _c('li', {
      class: {
        'active': _vm.groupId === group.group_id
      },
      on: {
        "click": function($event) {
          _vm.getGroupStores(group.group_id)
        }
      }
    }, [_c('em', [_vm._v(_vm._s(group.group_name))]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": require("./image/icon-edit.svg"),
        "alt": "编辑"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.updateGroup(group.group_id, group.group_name)
        }
      }
    }), _c('img', {
      attrs: {
        "src": require("./image/icon-delete.svg"),
        "alt": "删除"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteGroup(group.group_id, group.group_name)
        }
      }
    })])])
  })), _vm._v(" "), _c('footer', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleEditStatus()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? '完成' : '管理分组'))]), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.addGroup()
      }
    }
  }, [_vm._v("添加分组")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-table', {
    ref: "tabel",
    attrs: {
      "stripe": "",
      "data": _vm.storeList
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userid",
      "type": "selection",
      "width": "45"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "userid"
    }
  })]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopname",
      "label": "门店名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "group_name",
      "label": "所属分组"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body-footer"
  }, [_c('div', {
    staticClass: "operate"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupId !== 'vl'),
      expression: "groupId !== 'vl'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.deleteStoreFromGroup()
      }
    }
  }, [_vm._v("从组中移除")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupId === 'vl'),
      expression: "groupId === 'vl'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.updateStoreFromGroup()
      }
    }
  }, [_vm._v("门店分组")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.groupId !== 'vl'),
      expression: "groupId !== 'vl'"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.updateStoreFromGroup('update')
      }
    }
  }, [_vm._v("修改分组")])], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.storeCount > 0),
      expression: "storeCount > 0"
    }],
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.storeCount,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.getDialogTitle(_vm.groupType),
      "visible": _vm.dialogVisible,
      "show-close": false,
      "size": "tiny",
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.groupType === 'add') ? _c('div', {
    staticClass: "add-group"
  }, [_c('label', [_vm._v("分组名称")]), _vm._v(" "), _c('el-input', {
    ref: "addgroupinput",
    model: {
      value: (_vm.groupName),
      callback: function($$v) {
        _vm.groupName = $$v
      },
      expression: "groupName"
    }
  }), _vm._v(" "), (_vm.groupName) ? _c('p', {
    staticClass: "warn-tip",
    class: {
      'show': _vm.getByteLength() > 20
    }
  }, [_vm._v("分组名称不能超过20个字符")]) : _c('p', {
    staticClass: "warn-tip",
    class: {
      'show': _vm.isNullGroupName
    }
  }, [_vm._v("分组名称不能为空")])], 1) : _vm._e(), _vm._v(" "), (_vm.groupType === 'delete') ? _c('div', [_c('p', [_vm._v("您确定要删除" + _vm._s(_vm.groupName) + "分组吗？")])]) : _vm._e(), _vm._v(" "), (_vm.groupType === 'update') ? _c('div', {
    staticClass: "add-group"
  }, [_c('label', [_vm._v("分组名称")]), _vm._v(" "), _c('el-input', {
    ref: "updategroupinput",
    model: {
      value: (_vm.groupName),
      callback: function($$v) {
        _vm.groupName = $$v
      },
      expression: "groupName"
    }
  }), _vm._v(" "), (_vm.groupName) ? _c('p', {
    staticClass: "warn-tip",
    class: {
      'show': _vm.getByteLength() > 20
    }
  }, [_vm._v("分组名称不能超过20个字符")]) : _c('p', {
    staticClass: "warn-tip",
    class: {
      'show': _vm.isNullGroupName
    }
  }, [_vm._v("分组名称不能为空")])], 1) : _vm._e(), _vm._v(" "), (_vm.groupType === 'select') ? _c('div', [_c('label', [_vm._v("分组名称")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.selectedGroupId),
      callback: function($$v) {
        _vm.selectedGroupId = $$v
      },
      expression: "selectedGroupId"
    }
  }, _vm._l((_vm.groupList), function(group) {
    return _c('el-option', {
      key: group.group_id,
      attrs: {
        "label": group.group_name,
        "value": group.group_id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.groupType === 'deleteStore') ? _c('div', [_c('p', [_vm._v("您确定要将该门店从当前分组中移除吗？")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.groupType === 'add' || _vm.groupType === 'delete' || _vm.groupType === 'update') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.operateGroup()
      }
    }
  }, [_vm._v("确定")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.operateStoreFromGroup()
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1010659b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chainmanage/chaingroup.vue
// module id = 791
// module chunks = 1